$("html, body").animate({scrollTop: ($(window).scrollTop() + 1)});
$("html, body").animate({scrollTop: ($(window).scrollTop() - 1)});

// Collection List

$().ready(function(){
  $('.featured-collection-slider').slick({
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    dots: true,
    arrows: false,
    responsive: [
        {
          breakpoint: 1025,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 1000,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 430,
          settings: {
            slidesToShow: 1
          }
        }
      ]
  });
});


// Products 


$().ready(function(){
  $('.featured-product-slider').slick({
    slidesToShow: 3,
    infinite: true,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    prevArrow: '<svg class="slick-prev slick-arrow" width="58" height="58" viewBox="0 0 58 58" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="0.5" y="0.5" width="57" height="57" stroke="#1A1A1A"/><path d="M25.1545 28.6481L31.6795 22.1451C31.7834 22.0492 31.9204 21.9972 32.0618 22.0001C32.2032 22.003 32.338 22.0606 32.4379 22.1607C32.5377 22.2608 32.595 22.3958 32.5975 22.5372C32.6 22.6786 32.5477 22.8155 32.4515 22.9191L26.3175 29.0361L32.4545 35.1521C32.5507 35.2558 32.603 35.3927 32.6005 35.5341C32.598 35.6755 32.5407 35.8104 32.4409 35.9105C32.341 36.0107 32.2062 36.0682 32.0648 36.0711C31.9234 36.074 31.7864 36.0221 31.6825 35.9261L25.1605 29.4261C25.1095 29.3754 25.0691 29.3151 25.0415 29.2487C25.0139 29.1823 24.9997 29.111 24.9997 29.0391C24.9997 28.9672 25.0139 28.896 25.0415 28.8296C25.0691 28.7632 25.1095 28.7029 25.1605 28.6521L25.1545 28.6481Z" fill="#1A1A1A" stroke="#161616" stroke-width="2"/></svg>',
    nextArrow: '<svg class="slick-next slick-arrow" width="58" height="58" viewBox="0 0 58 58" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="-0.5" y="0.5" width="57" height="57" transform="matrix(-1 0 0 1 57 0)" stroke="#1A1A1A"/><path d="M32.8445 28.6481L26.3195 22.1451C26.2156 22.0492 26.0786 21.9972 25.9372 22.0001C25.7958 22.003 25.661 22.0606 25.5612 22.1607C25.4613 22.2608 25.4041 22.3958 25.4015 22.5372C25.399 22.6786 25.4513 22.8155 25.5475 22.9191L31.6815 29.0361L25.5445 35.1521C25.4483 35.2558 25.396 35.3927 25.3985 35.5341C25.4011 35.6755 25.4583 35.8104 25.5582 35.9105C25.658 36.0107 25.7928 36.0682 25.9342 36.0711C26.0756 36.074 26.2126 36.0221 26.3165 35.9261L32.8385 29.4261C32.8895 29.3754 32.93 29.3151 32.9576 29.2487C32.9852 29.1823 32.9994 29.111 32.9994 29.0391C32.9994 28.9672 32.9852 28.896 32.9576 28.8296C32.93 28.7632 32.8895 28.7029 32.8385 28.6521L32.8445 28.6481Z" fill="#1A1A1A" stroke="#161616" stroke-width="2"/></svg>',
    responsive: [
        {
          breakpoint: 1000,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            dots: true,
            arrows: false,
          }
        }
      ]
  });
});


// Product Slider 2


$().ready(function(){
  $('.featured-product-slider-2').slick({
    slidesToShow: 4,
    infinite: false,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    prevArrow: '<svg class="slick-prev slick-arrow" width="58" height="58" viewBox="0 0 58 58" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="0.5" y="0.5" width="57" height="57" stroke="#1A1A1A"/><path d="M25.1545 28.6481L31.6795 22.1451C31.7834 22.0492 31.9204 21.9972 32.0618 22.0001C32.2032 22.003 32.338 22.0606 32.4379 22.1607C32.5377 22.2608 32.595 22.3958 32.5975 22.5372C32.6 22.6786 32.5477 22.8155 32.4515 22.9191L26.3175 29.0361L32.4545 35.1521C32.5507 35.2558 32.603 35.3927 32.6005 35.5341C32.598 35.6755 32.5407 35.8104 32.4409 35.9105C32.341 36.0107 32.2062 36.0682 32.0648 36.0711C31.9234 36.074 31.7864 36.0221 31.6825 35.9261L25.1605 29.4261C25.1095 29.3754 25.0691 29.3151 25.0415 29.2487C25.0139 29.1823 24.9997 29.111 24.9997 29.0391C24.9997 28.9672 25.0139 28.896 25.0415 28.8296C25.0691 28.7632 25.1095 28.7029 25.1605 28.6521L25.1545 28.6481Z" fill="#1A1A1A" stroke="#161616" stroke-width="2"/></svg>',
    nextArrow: '<svg class="slick-next slick-arrow" width="58" height="58" viewBox="0 0 58 58" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="-0.5" y="0.5" width="57" height="57" transform="matrix(-1 0 0 1 57 0)" stroke="#1A1A1A"/><path d="M32.8445 28.6481L26.3195 22.1451C26.2156 22.0492 26.0786 21.9972 25.9372 22.0001C25.7958 22.003 25.661 22.0606 25.5612 22.1607C25.4613 22.2608 25.4041 22.3958 25.4015 22.5372C25.399 22.6786 25.4513 22.8155 25.5475 22.9191L31.6815 29.0361L25.5445 35.1521C25.4483 35.2558 25.396 35.3927 25.3985 35.5341C25.4011 35.6755 25.4583 35.8104 25.5582 35.9105C25.658 36.0107 25.7928 36.0682 25.9342 36.0711C26.0756 36.074 26.2126 36.0221 26.3165 35.9261L32.8385 29.4261C32.8895 29.3754 32.93 29.3151 32.9576 29.2487C32.9852 29.1823 32.9994 29.111 32.9994 29.0391C32.9994 28.9672 32.9852 28.896 32.9576 28.8296C32.93 28.7632 32.8895 28.7029 32.8385 28.6521L32.8445 28.6481Z" fill="#1A1A1A" stroke="#161616" stroke-width="2"/></svg>',
    responsive: [
        {
          breakpoint: 1025,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 1000,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            dots: true,
            arrows: false
          }
        }
      ]
  });
});

$().ready(function(){
  $('.abz_testimonial_sec').slick({
    slidesToShow: 1,
    infinite: true,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    prevArrow: '<svg class="slick-prev slick-arrow" width="58" height="58" viewBox="0 0 58 58" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="0.5" y="0.5" width="57" height="57" stroke="#1A1A1A"/><path d="M25.1545 28.6481L31.6795 22.1451C31.7834 22.0492 31.9204 21.9972 32.0618 22.0001C32.2032 22.003 32.338 22.0606 32.4379 22.1607C32.5377 22.2608 32.595 22.3958 32.5975 22.5372C32.6 22.6786 32.5477 22.8155 32.4515 22.9191L26.3175 29.0361L32.4545 35.1521C32.5507 35.2558 32.603 35.3927 32.6005 35.5341C32.598 35.6755 32.5407 35.8104 32.4409 35.9105C32.341 36.0107 32.2062 36.0682 32.0648 36.0711C31.9234 36.074 31.7864 36.0221 31.6825 35.9261L25.1605 29.4261C25.1095 29.3754 25.0691 29.3151 25.0415 29.2487C25.0139 29.1823 24.9997 29.111 24.9997 29.0391C24.9997 28.9672 25.0139 28.896 25.0415 28.8296C25.0691 28.7632 25.1095 28.7029 25.1605 28.6521L25.1545 28.6481Z" fill="#1A1A1A" stroke="#161616" stroke-width="2"/></svg>',
    nextArrow: '<svg class="slick-next slick-arrow" width="58" height="58" viewBox="0 0 58 58" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="-0.5" y="0.5" width="57" height="57" transform="matrix(-1 0 0 1 57 0)" stroke="#1A1A1A"/><path d="M32.8445 28.6481L26.3195 22.1451C26.2156 22.0492 26.0786 21.9972 25.9372 22.0001C25.7958 22.003 25.661 22.0606 25.5612 22.1607C25.4613 22.2608 25.4041 22.3958 25.4015 22.5372C25.399 22.6786 25.4513 22.8155 25.5475 22.9191L31.6815 29.0361L25.5445 35.1521C25.4483 35.2558 25.396 35.3927 25.3985 35.5341C25.4011 35.6755 25.4583 35.8104 25.5582 35.9105C25.658 36.0107 25.7928 36.0682 25.9342 36.0711C26.0756 36.074 26.2126 36.0221 26.3165 35.9261L32.8385 29.4261C32.8895 29.3754 32.93 29.3151 32.9576 29.2487C32.9852 29.1823 32.9994 29.111 32.9994 29.0391C32.9994 28.9672 32.9852 28.896 32.9576 28.8296C32.93 28.7632 32.8895 28.7029 32.8385 28.6521L32.8445 28.6481Z" fill="#1A1A1A" stroke="#161616" stroke-width="2"/></svg>',
    responsive: [
        {
          breakpoint: 990,
          settings: {
            slidesToShow: 1,
            dots: true
          }
        }
      ]
  });
});

